import { ReactElement } from 'react';

import ErrorTwoToneIcon from '@mui/icons-material/ErrorTwoTone';
import { useTheme, InputAdornment, Tooltip, Grow } from '@mui/material';

import { ErrorAdornmentProps } from './types';

export default function ErrorAdornment(props: ErrorAdornmentProps): ReactElement {
  const theme = useTheme();

  const { display = false, errorMessage = '', openErrorTooltip = false } = props;

  return (
    <Grow in={display} timeout={theme.transitions.duration.short}>
      <InputAdornment position='end' variant='standard'>
        <Tooltip open={openErrorTooltip} title={errorMessage || ''} placement='top'>
          <ErrorTwoToneIcon />
        </Tooltip>
      </InputAdornment>
    </Grow>
  );
}
